import moment, { Moment } from "moment-timezone";
import ApiDateParser from "../../helpers/parsers/apiDateParser";

export default class BaseModel {
  id: number;
  created_at?: Moment | null;
  updated_at?: Moment | null;
  object_type?: string;
  constructor(arg: any) {
    this.id = !!arg?.id ? arg?.id : 0;
    this.object_type = arg.object_type;
    this.created_at = !!arg?.created_at
      ? ApiDateParser.parse(arg?.created_at!)
      : moment();

    this.updated_at = !!arg?.updated_at
      ? ApiDateParser.parse(arg?.updated_at!)
      : moment();
  }

  static fromApiResponse(data: any): any {
    if (Array.isArray(data)) {
      if (data.length > 0) {
        return data.map((val: any) => new this(val));
      } else {
        return [];
      }
    } else if (!!data) {
      return new this(data);
    }
    return [];
  }

  static collectionFromApiResponse(data: any): any {
    if (Array.isArray(data)) {
      if (data.length > 0) {
        return data.map((val: any) => new this(val));
      } else {
        return [];
      }
    } else if (!!data) {
      return [new this(data)];
    }
    return [];
  }
}
